import { useMemo } from 'react';

import { usePuidsSelector } from 'shared/hooks/usePuidsSelector';

import type { PParams } from '../../types';

export function useAdfoxParameters(pParams: PParams): Record<string, string> {
  const puids = usePuidsSelector();

  return useMemo<Record<string, string>>(() => ({ ...pParams, ...puids }), [pParams, puids]);
}
